// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OAKj","col":"styles_col__3zpMs"};